// 帮助中心-视频教程组件使用
import * as types from '@/store/mutations-types'

// state
const state = {
  vedioTeachDialog: false // 新增弹窗
}
// action
const action = {}
// mutations
const mutations = {
  [types.VEDIO_TEACH_DIALOG] (state, vedioTeachDialog) {
    state.vedioTeachDialog = vedioTeachDialog
  }
}

export default {
  state,
  action,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/help/vedio-teach.js